class EmployeeConfig {
  static Employee_Notifications_Center_Endpoints = () => ({
    notificationsCenterList: 'notifications/center',
    notificationCenterBell: 'notifications/center/bell',
  })

  static Employee_NotificationsInbox_Endpoints = (id) => ({
    notificationsInbox: 'notifications/inbox',
    notificationsInboxDetails: `notifications/inbox/details/${id}`,
    notificationsInboxRequestHistory: `notifications/inbox/details/${id}/tracking`,
    notificationsInboxActions: `notifications/inbox/${id}`,
    notificationInboxBell: 'notifications/inbox/bell',
    notificationsInboxSelected: `notifications/inbox/${id}/bulk`,
  })

  static Employee_NotificationsActionHistory_Endpoints = () => ({
    notificationsActionHistory: 'action/history',
  })

  static Attachment_Endpoints = (groupId, attachmentId) => ({
    createGroup: 'attachments/groups',
    addAttachmentToGroup: `attachments/groups/${groupId}/attachments`,
    deleteSingleAttachment: `attachments/groups/${groupId}/attachments/${attachmentId}`,
    getGroupAttachmentsByGroupIds: 'attachments/groups',
    downloadAttachmentById: `attachments/groups/${groupId}/attachments/${attachmentId}/download`,
  })

  static Import_Users_Roles_Endpoints = () => ({
    createFile: '/companies/users-roles/bulk',
    getRoles: 'companies/roles',
  })

  static Import_Users_Roles_Details_Endpoints = (id) => ({
    getImportUsersRolesDetails: `/companies/batch/process/${id}`,
    getImportUsersRolesDetailsUsers: `/companies/batch/process/${id}/users-roles`,
    downloadFailedFile: `/companies/batch/process/${id}/users-roles/export-failed`,
  })
}

export default EmployeeConfig
